module.exports = __webpack_public_path__ + "static/media/biFOMO.63923090.jpg";